import { render, staticRenderFns } from "./DocumentPreview.vue?vue&type=template&id=b892efac&scoped=true&"
import script from "./DocumentPreview.vue?vue&type=script&lang=ts&"
export * from "./DocumentPreview.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPreview.vue?vue&type=style&index=0&id=b892efac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b892efac",
  null
  
)

export default component.exports